import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIConstants } from '../../../../_config/restapis';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';

@Injectable()
export class APITemplateService {

    constructor(
        private http: HttpClient,
        private db: $DBManagerService,
        private evt: $BroadcastManagerService
    ) { }

    public download(file1): Observable<any> {

        return this.http.post(APIConstants.FILEDOWNLOAD, file1, { responseType: "blob" });
    }
    public templatefiledownload(file1): Observable<any> {

        return this.http.post(APIConstants.TEMPLATEFILEDOWNLOAD, file1, { responseType: "blob" });
    }
    public headerFileDownload(file1): Observable<any> {

        return this.http.post(APIConstants.FILEDOWNLOAD, file1, { responseType: "blob" });
    }
    public modifyFileDownload(file1): Observable<any> {

        return this.http.post(APIConstants.MODIFYFILEDOWNLOAD, file1, { responseType: "blob" });
    }
    public bulkContentUpload(data: any): Observable<any> {
        console.log("serive file ------------- ", data);
        return this.http.post(APIConstants.CONTENTBULKUPLOAD, data);
    }
    public getCtBulkSummaryAll(entityId): Observable<any> {
        console.log("inside get all entity");
        return this.http.get(APIConstants.GETCTBULKUPLOADSUMMARY + '/' + entityId);
    }
    public getConsentBulkSummaryFilter(data: any): Observable<any> {
        console.log("serive file", data);
        return this.http.post(APIConstants.CONSENTBULKSUMMARYFILTER, data);
    }
    public downloadCstBulk(BatchId): Observable<any> {
        console.log("batchId", BatchId)
        return this.http.post(APIConstants.DOWNLOADCSTBULKUPLOAD, BatchId, { responseType: "blob" });
    }


    //  public fetchEntityDetails(data): Observable<any>{
    //     console.log("in service");
    //     return this.http.post(APIConstants.FETCHENTITYDETAILS, data);
    // }


    public getEntitySummaryforApproval(Tsp): Observable<any> {
        return this.http.get(APIConstants.GETALLENTITYFORAPPROVAL + Tsp);

    }

    public updateEntitySummaryforApproval(data): Observable<any> {
        console.log("inside api update entity");
        let a = this.http.post(APIConstants.UPDATEENTITYDETAILSMONGO, data);
        // console.log("a",a);
        // console.log("a",JSON.stringify(a));
        return a;
        // return this.http.get(APIConstants.INVOKE);

    }

    public getAllEntitySummary(tsp): Observable<any> {
        console.log("inside get all entity");
        return this.http.get(APIConstants.GETENTITYSUMMARY + tsp);
        /*   return this.http.get(APIConstants.GETENTITYSUMMARY+tsp).pipe(map((data: any) => data.result )); */

    }
    public getEntityRoles(): Observable<any> {
        //  console.log("inside get all entity");
        return this.http.get(APIConstants.GETENTITYROLES);
        /*   return this.http.get(APIConstants.GETENTITYSUMMARY+tsp).pipe(map((data: any) => data.result )); */

    }

    public getProcessOwnerRoles(selected): Observable<any> {
        return this.http.get(APIConstants.GETPROCESSOWNERROLES + '/' + selected);
    }

    public getProcessOwnerDetails(tataID): Observable<any> {
        return this.http.get(APIConstants.GETPROCESSOWNERDETAILS+'/'+tataID); 
    }

    public getProcessRolesModify(selectedValue, entityID): Observable<any> { 
        return this.http.get(APIConstants.GETPROCESSROLESMODIFY + '/' + selectedValue  + '/' + entityID);   
    }



    public getProcessRoles(selectedValue): Observable<any> {
        return this.http.get(APIConstants.GETPROCESSROLES + '/' + selectedValue);

        // public getProcessRoles(): Observable<any> { 
        //     return this.http.get(APIConstants.GETPROCESSROLES);   
    }


    public hideProcessOwnerRoles(selected): Observable<any> {
        return this.http.get(APIConstants.HIDEPROCESSOWNERROLES + '/' + selected);
    }




    public entityIdVerification(entityId): Observable<any> {
        console.log("inside get all entity", entityId);
        let a = this.http.get(APIConstants.VALIDATEENTITYID + entityId);
        console.log("aaaaa /...", a);
        return this.http.get(APIConstants.VALIDATEENTITYID + entityId, { responseType: 'text' });
        // return this.http.get(APIConstants.INVOKE);

    }

    public getComplaintsForVirtualID(): Observable<any> {
        // console.log("inside mob call complaint :",MobileNo);
        let virtual_id = this.db.get(Constants.SESSSION_STORAGE, Constants.VIRTUAL_MOB_ID);
        let serviceProvider = "RJIO";
        return this.http.get(APIConstants.GETSUBSCRIBERANDPREFERENCEDETAILS + virtual_id + '/' + serviceProvider);
        // return this.http.get(APIConstants.GETSUBSCRIBERCOMPLAINTSBYMOBILENOCOMPLAINTNO+MobileNo);
    }


    private parseRjioComplaints(res: any): any {
        const data = res.reduce((acc, val) => {
            acc.push({
                'Complaint_No': val.Record.Complaint_No,
                'ComplaintDate': val.Record.ComplaintDate,
                'MobileNo': val.Record.MobileNo,
                'TSP_Name': val.Record.TSP_Name,
                'TM_Type': val.Record.TM_Type,
                'IncidentDate': val.Record.IncidentDate,
                'ComplaintDesc': val.Record.ComplaintDesc,
                'Status': val.Record.Status,
                'TM_No_Header': val.Record.TM_No_Header,
                'ProviderDesc': val.Record.ProviderDesc
            });
            return acc;
        }, []);
        console.log("data :", data);
        return data;
    }



    public complaintsSubscriber(data: any): Observable<any> {
        return this.http.post(APIConstants.INVOKE, data);
    }

    public complaintUpdateByTAP(data: any): Observable<any> {
        return this.http.post(APIConstants.INVOKE, data);
    }

    public actionByOAP(data: any): Observable<any> {
        return this.http.post(APIConstants.INVOKE, data);
    }

    public actionByTSP(data: any): Observable<any> {
        return this.http.post(APIConstants.INVOKE, data);
    }

    public getHeaderData(): Observable<any> {
        let sp = this.db.get(Constants.SESSSION_STORAGE, Constants.SP);
        return this.http.get(APIConstants.GET_HEADERS_FOR_APPROVAL + sp)
            .pipe(map(r => this.parseHeaderData(r)))
    }
    public getHeaderDataForTSP(): Observable<any> {
        let sp = this.db.get(Constants.SESSSION_STORAGE, Constants.SP);
        let serviceprovider = this.db.get(Constants.SESSSION_STORAGE, Constants.SERVICE_PROVIDER);
        return this.http.get(APIConstants.GETALLHEADERFORTSP + sp)
            .pipe(map(r => this.parseHeaderDataTSP(r)))
    }

    private parseHeaderData(res: any): any {
        let modRes = res.reduce((acc, val) => {
            acc.push({
                'Header_Name': val.Record.Header_Name,
                'Header_Content': val.Record.Content_Desc,
                'TM': val.Record.RTM_No,
                'Category': val.Record.Category_Type
            });
            return acc;
        }, []);
        return modRes;
    }

    private parseHeaderDataTSP(res: any): any {
        let modRes = res.reduce((acc, val) => {
            acc.push({
                'Header_Name': val.Record.Header_Name,
                'Header_Content': val.Record.Content_Desc,
                'TM': val.Record.RTM_No,
                'Category': val.Record.Category_Type,
                'Status': val.Record.Status
            });
            return acc;
        }, []);
        return modRes;
    }

    public approveORReject(headerName: string, status: string): Observable<any> {
        let todayDate = new Date();
        let data = {
            "header": {
                "event_const": "CNST_APPROVE_HEADER_EVENT",
                "head_id": 123
            },
            "jsonblob": {
                "Header_Name": headerName,
                "TSP_Approve_Date": todayDate,
                "Status": status
            }
        }
        return this.http.post(APIConstants.INVOKE, data);
    }


    public getAllEntityForApprovalFilter(param, fdate, ldate): Observable<any> {
        return this.http.get(APIConstants.GETALLENTITYFORAPPROVALFILTER + param + '/' + fdate + '/' + ldate);

    }

    public getAllEntityFilter(param, fdate, ldate): Observable<any> {
        return this.http.get(APIConstants.GETALLENTITYFILTER + param + '/' + fdate + '/' + ldate);

    }


    public getAllActEntitySummaryMongo(status): Observable<any> {  
        console.log(" status for checking in service", status) 

        return this.http.post(APIConstants.GETACTDEACTENTITYSUMMARYMONGO, status);

    }

    public deactivateActivateEntity(data): Observable<any> {
        console.log("deactivate the entity service", data)
        return this.http.post(APIConstants.ACTIVATEENTITY, data)
    }    

    // new entity summary from mongo

    public getAllNewEntitySummaryMongo(status): Observable<any> {
        console.log(" status for checking in service", status)

        return this.http.post(APIConstants.GETENTITYSUMMARYMONGO, status);

    }
    //Summary for invite users 

    public getInvitedUserSummary(inviteId): Observable<any> {
        console.log(" inviteId for checking in service", inviteId)

        return this.http.post(APIConstants.INVITEUSER, inviteId);

    }

    //deactivate the entity 
    public deactivateEntitySerive(data): Observable<any> {
        console.log("deactivate the entity service", data)
        return this.http.post(APIConstants.DEACTIVATEENTITY, data)
    }

    public downloadcsv(Status): Observable<any> {
        console.log("batch id issssssssssss", Status)
        return this.http.get(APIConstants.DOWNLOADENTITYDETAILS + '/' + Status, { responseType: "blob" });
    }

    public getContentEntityDetails(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.GETCONTENTENTITYDETAILS, data);  
    }

    public fetchEntityDetails(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.FETCHENTITYDETAILS, data);
    }
    public fetchEntityDetails1(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.FETCHENTITYDETAILS1, data);
    }
    public fetchEntityDetails2(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.FETCHENTITYDETAILS2, data);
    }
    public generateotp(data): Observable<any> {
        console.log("in service");
        return this.http.post(APIConstants.GENERATEENTITYOTP, data);
    }
    public getEntityDetailsByRefNo(data): Observable<any> {
        console.log("in service");
        console.log("dataaaaa", data)
        return this.http.post(APIConstants.GETENTITYDETAILSBYREFNO, data);
    }
    public getEntityStatus(BatchId): Observable<any> {
        return this.http.get(APIConstants.GETENTITYSTATUS + '/' + BatchId);
    }
    public verifyEntityStatusOTP(data): Observable<any> {

        console.log("data:" + JSON.stringify(data));
        const headers = new HttpHeaders();
        headers.set('content-type', null);
        headers.set('Accept', 'multipart/form-data');


        let b = this.http.post(APIConstants.VERIFYENTITYSTATUSOTP, data, { headers });
        return b;

    }

  	public TMPEentityRegistration(data: FormData): Observable<any>{
        console.log("dataaaaa",data)
		 const headers = new HttpHeaders();
		headers.set('content-type', null);
		headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.TMPEENTITYREGISTRATION, data, { headers }); 
    }
	
	public TMPEentityEmailVerification(data): Observable<any>{
        console.log("dataaaaa",data)
		 const headers = new HttpHeaders();
		headers.set('content-type', null);
		headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.TMPEENTITYEMAILVERIFICATION, data, { headers });  
    }
	public forgotpwdEmailVerification(data): Observable<any>{       
        console.log("dataaaaasengathirsms",data)      
		 const headers = new HttpHeaders();
		headers.set('content-type', null);
		headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.FORGOTPWdEmailVerification, data, { headers });           
    }
	public forgotpwdSmsVerification(data): Observable<any>{      
        console.log("dataaaaasengathir",data)    
		 const headers = new HttpHeaders();
		headers.set('content-type', null);
		headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.FORGOTPWdsmsVerification, data, { headers });           
    }
	public changepwdVerification(data): Observable<any>{        
        console.log("dataaaaasengathir",data)       
		 const headers = new HttpHeaders();
		headers.set('content-type', null);
		headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.changePWdVerification, data, { headers });           
    }
	
	public TMPEentityMobileVerification(data): Observable<any>{ 
        console.log("dataaaaa",data)
		 const headers = new HttpHeaders();
		headers.set('content-type', null);
		headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.TMPEENTITYMOBILEVERIFICATION, data, { headers }); 
    }
	
	public TMPEentityPwdRegistration(data): Observable<any>{
        console.log("dataaaaa",data)
		 const headers = new HttpHeaders(); 
		headers.set('content-type', null);  
		headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.TMPEENTITYPWDREGISTRATION, data, { headers }); 
    }
	public ForgetPwdChange(data): Observable<any>{
        console.log("dataaaaa",data)
		 const headers = new HttpHeaders(); 
		headers.set('content-type', null);  
		headers.set('Accept', 'multipart/form-data');    
        return this.http.post(APIConstants.FORGOTPEWCHANGE, data, { headers }); 
    }
	public PwdChange(data): Observable<any>{
        console.log("dataaaaa",data)
		 const headers = new HttpHeaders();     
		headers.set('content-type', null);  
		headers.set('Accept', 'multipart/form-data');      
        return this.http.post(APIConstants.PEWCHANGE, data, { headers }); 
    }
    
	public resendEntityOtp(data): Observable<any>{
        console.log("dataaaaa",data)
		 const headers = new HttpHeaders(); 
		headers.set('content-type', null);  
		headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.RESENDENTITYOTP, data, { headers }); 
    }
	public resendemailsmsOtp(data): Observable<any>{      
        console.log("dataaaaa",data)
		 const headers = new HttpHeaders(); 
		headers.set('content-type', null);  
		headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.RESENDEmailSmsOTP, data, { headers });      
    }
	public resendOtp(data): Observable<any>{      
        console.log("dataaaaa",data)
		 const headers = new HttpHeaders(); 
		headers.set('content-type', null);  
		headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.RESENDOTPchange, data, { headers }); 
    }

	public TMPEentityUpdation(data): Observable<any>{
        console.log("dataaaaa",data)
		 const headers = new HttpHeaders(); 
		headers.set('content-type', 'application/json');  
		headers.set('Accept', 'multipart/form-data');
		headers.set('Access-Control-Allow-Origin',"*");
        return this.http.post(APIConstants.TMPEENTITYUPDATION, data, { headers }); 
    }
	
	public getTMPEEntityDetails(data): Observable<any>{ 
        console.log("dataaaaa",data)
		 const headers = new HttpHeaders(); 
		headers.set('content-type', null);  
		headers.set('Accept', 'multipart/form-data');
        return this.http.post(APIConstants.GETPETMEXISTINGENTITYDETAILS, data, { headers }); 
    }
	
	public tataModification(data : any): Observable<any>{
        return this.http.post(APIConstants.TATAMODIFICATION, data);
    }
	
	
    public getRegisteredDetails(data): Observable<any> {
        //  console.log(" status for checking in service",status)

        return this.http.get(APIConstants.GETREGISTEREDDETAILS+'/'+data);

    }

    public mobileOTPModifybeforeReg(data): Observable<any> {
        //  console.log(" status for checking in service",status)

        return this.http.post(APIConstants.MOBILEOTPMODIFYBEFOREREG, data);

    }
    public emailOTPModifybeforeReg(data): Observable<any> {
        //  console.log(" status for checking in service",status)

        return this.http.post(APIConstants.EMAILOTPMODIFYBEFOREREG, data);

    }
    public emailVerifyOTPModifybeforeReg(data): Observable<any> {
        //  console.log(" status for checking in service",status)

        return this.http.post(APIConstants.EMAILVERIFYOTPMODIFYBEFOREREG, data);

    }
    public mobileVerifyOTPModifybeforeReg(data): Observable<any> {
        //  console.log(" status for checking in service",status)

        return this.http.post(APIConstants.MOBILEVERIFYOTPMODIFYBEFOREREG, data);
  
    }
    public deleteBlobIfExists(data): Observable<any> {    
        //  console.log(" status for checking in service",status)

        return this.http.post(APIConstants.DELETEBLOBIFEXISTS, data);

    }
    public modifyRegistrationTMPE01(data): Observable<any> {
        //  console.log(" status for checking in service",status)

        return this.http.post(APIConstants.MODIFYREGISTRATIONTMPE01, data);
    }

    public ContentEntityRegistration(data): Observable<any> {   
        //  console.log(" status for checking in service",status)

        return this.http.post(APIConstants.CONTENTENTITYREGISTRATION, data);
    }   

    public checkPanExists(data): Observable<any> {
        //  console.log(" status for checking in service",status)

        return this.http.post(APIConstants.CHECKPANEXISTS, data);

    }
    public updateTemplate(data): Observable<any> {
        //  console.log(" status for checking in service",status)

        return this.http.post(APIConstants.UPDATETEMPLATE, data);

    }

    public getTemplateDetails(data): Observable<any> {
        //  console.log(" status for checking in service",status)    

        return this.http.post(APIConstants.GETTEMPLATEDETAILS, data);
  
    }

    public getDetailsFromURN(data): Observable<any> {
        //  console.log(" status for checking in service",status)
        return this.http.post(APIConstants.GETDETAILSFROMURN, data);   
   
    }     

    public getTemplateSummaryMongo(data): Observable<any> {  
        console.log(" status for checking in service ---  ", data)
        return this.http.post(APIConstants.GETTEMPLATESUMMARYMONGO, data); 
    }  
    public downloadTemplates(data): Observable<any> {  
        console.log(" status for checking in service ---  ", data)
        return this.http.post(APIConstants.DOWNLOADTEMPLATES, data, { responseType: "blob" });  
    } 
    public deleteTemplateFile(data): Observable<any> {    
        //  console.log(" status for checking in service",status)

        return this.http.post(APIConstants.DELETETEMPLATEFILE, data);

    }
    public ContentEntityModification(data): Observable<any> {   
        //  console.log(" status for checking in service",status)
    
        return this.http.post(APIConstants.CONTENTENTITYMODIFICATION, data);
    }

    public getTemplateSummaryFilter(data: any): Observable<any> { 
        console.log("serive file",data);
        return this.http.post(APIConstants.GETTEMPLATESUMMARYFILTER, data);        

    }

    public getnonTTLTemplates(data): Observable<any> {	
        return this.http.post(APIConstants.GETNONTTLTEMPLATES,data);
    }

    public searchNonTTLTemplates(data): Observable<any> {
        return this.http.post(APIConstants.SEARCHNONTTLTEMPLATES,data);
    }
    
    public exportnonTTLTemplates(data): Observable<any> {

        return this.http.post(APIConstants.EXPORTNONTTLTEMPLATES, data, { responseType: "blob" });
    }

    public verifyTemplates(data): Observable<any> {
        return this.http.post(APIConstants.VERIFYTEMPLATES,data);
    }

    public contenttemplatechange(data): Observable<any> {
        return this.http.post(APIConstants.CONTENTTEMPLATECHANGE,data);  
    }

    public getTemplateInfoForPE(data): Observable<any> {
        return this.http.post(APIConstants.GETTEMPLATEFORPEID,data);  
    }

    public verificationreport(file: any): Observable<any> {  
        return this.http.post(APIConstants.VERIFICATIONREPORT, file, { responseType: "blob" });     
       
    }

    public updateTmpVerification(data): Observable<any>{
        console.log("data   ",data);
         const headers = new HttpHeaders(); 
         headers.set('content-type', 'application/json');  
         headers.set('Accept', 'multipart/form-data');
         headers.set('Access-Control-Allow-Origin',"*");
         return this.http.post(APIConstants.UPDATETMPVERIFICAATION,data,{ headers });
 
      }

      public tmpVerificationSummaryReport(data): Observable<any> {
        return this.http.post(APIConstants.TMPVERIFICATIONSUMMARYREPORT,data);
    }

    public updateTmpVerificationSummary(data): Observable<any> {
        return this.http.post(APIConstants.UPDATETMPVERIFICATIONSUMMARY, data, { responseType: "blob" });
    }

}